module.exports = __webpack_public_path__ + "static/media/desktop_settings.08eae2a5.svg";